export default "__VITE_ASSET__97a302ed__"